var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto"},[_c('c1PickVehicleStepForm',{attrs:{"P_customerType":_vm.P_customerType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }